// extracted by mini-css-extract-plugin
export default {"wrapper":"PageError_wrapper__tF95D","title":"PageError_title__-NXtb","text":"PageError_text__RXEp4"};